import React, {useRef} from 'react';
import cx from 'clsx';
import {Header} from './Components/Header/Header';
import {classes, st} from './SideCart.st.css';
import {Footer} from './Components/Footer/Footer';
import {Body} from './Components/Body/Body';
import './vars.scss';
import {SideCartAppDataHook, SideCartProps} from './SideCart.types';
import {ErrorToast} from '../../../common/components/ErrorToast/ErrorToast';
import {useExperiments, useTranslation} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../../../domain/controllers/ControllerContext';
import {SPECS} from '../../../domain/specs';
import {PriceBreakdown} from './Components/PriceBreakdown/PriceBreakdown';
import {CustomerInputSection} from './Components/CustomerInputSection/CustomerInputSection';
import {CrossSell} from '../../../common/components/CrossSell/CrossSell';
import {SlotPlaceHolder} from '../../../common/components/SlotPlaceHolder/SlotPlaceHolder';
import {SlotsMap} from '../../../common/constants';

export const SideCart = ({dir}: SideCartProps) => {
  const editorBrand = window?.commonConfig?.brand;
  const isStudioOrEditorXSite = editorBrand === 'editorx' || editorBrand === 'studio';
  const closeButtonRef = useRef<HTMLButtonElement>(null);
  const onItemRemoved = () => closeButtonRef?.current?.focus();
  const {t} = useTranslation();
  const {experiments} = useExperiments();

  const {shouldRenderEmptyState} = useControllerProps().cartStore;
  const shouldRenderCustomerInputSection = !shouldRenderEmptyState;
  const shouldRenderPriceBreakdown = !shouldRenderEmptyState;

  return (
    <main
      dir={dir}
      aria-label={t('sideCart.mainFrame.ariaLabel')}
      data-hook={SideCartAppDataHook.root}
      className={cx(
        st('sideCart', classes.container, ...(isStudioOrEditorXSite ? [classes.responsiveEditor] : [])),
        experiments.enabled(SPECS.ecomCartCssVars) && 'cart-css-vars'
      )}
      data-wix-side-cart>
      <div className={shouldRenderCustomerInputSection ? classes.headerAndBody : classes.headerAndBodyOld}>
        <Header closeButtonRef={closeButtonRef} />
        <SlotPlaceHolder slotId={SlotsMap.SideCartHeaderAfter1} className={classes.headerAfter1Slot} />
        <Body onItemRemoved={onItemRemoved} />
        {!shouldRenderEmptyState && <CrossSell />}
        {shouldRenderCustomerInputSection && <CustomerInputSection />}
        {shouldRenderPriceBreakdown && <PriceBreakdown />}
      </div>
      <div className={classes.footer}>
        <Footer />
      </div>
      <div className={classes.toastContainer}>
        <ErrorToast />
      </div>
    </main>
  );
};
